import { render, staticRenderFns } from "./NewsPromotion.vue?vue&type=template&id=e9ff8300&"
import script from "./NewsPromotion.vue?vue&type=script&lang=js&"
export * from "./NewsPromotion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports